export default {"src":"/_next/static/media/ArrowDown.587e2456.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};